import React, { useEffect, useState } from "react";
import { Smartphone } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import api, { apiError } from "@/lib/api";
import { useLang } from "@/i18n";
import { useCamp } from "@/context/SettingsContext";
import { Panel } from "@/pages/shared";

const NUM = ["plan_w", "plan_h", "calib_nw_lat", "calib_nw_lng", "calib_se_lat", "calib_se_lng", "calib_bearing", "calib_opacity"];
const FIELDS = [
  ["plan_w", "plan_width"], ["plan_h", "plan_height"],
  ["calib_nw_lat", "calib_nw_lat"], ["calib_nw_lng", "calib_nw_lng"],
  ["calib_se_lat", "calib_se_lat"], ["calib_se_lng", "calib_se_lng"],
  ["calib_bearing", "calib_bearing"], ["calib_opacity", "calib_opacity"],
];

// Plattegrond-afmetingen en GPS-kalibratie voor de mobiele apps (Inspection / Visitors).
export default function MobileAppPanel() {
  const { t } = useLang();
  const { camp, reload } = useCamp();
  const [form, setForm] = useState({});
  const [saving, setSaving] = useState(false);

  useEffect(() => { setForm(Object.fromEntries(FIELDS.map(([k]) => [k, camp[k] ?? ""]))); }, [camp]);

  const save = async () => {
    setSaving(true);
    try {
      const body = { plan_unit: "px" };
      NUM.forEach((k) => { body[k] = form[k] === "" || form[k] == null ? null : Number(form[k]); });
      await api.patch("/settings", body);
      await reload();
      toast.success(t("saved"));
    } catch (e) { toast.error(apiError(e.response?.data?.detail)); }
    finally { setSaving(false); }
  };

  return (
    <Panel title={t("mobile_apps")} testid="admin-mobile-panel">
      <div className="p-5 space-y-4">
        <p className="text-sm text-muted-foreground">{t("mobile_apps_hint")}</p>
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
          {FIELDS.map(([k, key]) => (
            <div key={k} className="space-y-1.5">
              <Label htmlFor={`mob-${k}`} className="text-[11px]">{t(key)}</Label>
              <Input id={`mob-${k}`} value={form[k] ?? ""} inputMode="decimal"
                onChange={(e) => setForm((f) => ({ ...f, [k]: e.target.value }))} data-testid={`mobile-${k}`} />
            </div>
          ))}
        </div>
        <p className="text-[11px] text-muted-foreground">{t("plan_unit_px")}</p>
        <Button onClick={save} disabled={saving} data-testid="mobile-save">
          <Smartphone className="h-4 w-4 mr-2" />{t("save")}
        </Button>
      </div>
    </Panel>
  );
}
